<div class="container-fluid webView bzMatTbl shadow">
    <!-- Header -->
    <div class="row" style="margin: 0px;">

        <div class="col-md-4" style="padding: 10px 10px 0px 5px; font-size: 30px;">
            <span class="mobView" style="font-size: 22px; margin-right: 10px;" (click)="backBtn()"><i
                    class="fa fa-chevron-left"></i></span>

            <h4 style="padding-right: 15px; display: inline-block;" class="lblHeader newHeader"> Balance Sheet</h4>

        </div>
        <div class="col-md-8" style="text-align: right; padding: 25px 2px 0px 15px;">
            <div class="orangeBadgeCnt" style="display: inline-block; margin-right: 10px; font-size: 13px;" *ngIf="imBaalance != 0" (click)="selectedFY == currentFY ? resetImbalance() : ''" title="Reset Imbalance">
                Imbalance : <span style="font-family: Arial;font-size: 13px;">₹ {{imBaalance | cRDB}} </span>
            </div>

            <div (click)="refresh()" class="orangeButton"style="margin-right: 10px; vertical-align: middle; cursor: pointer;" title="Refresh">
                <span><i aria-hidden="true" style="font-size: 13px;" class="fa fa-refresh"></i> </span>
            </div>

            <div title="Print" (click)="Print()" class="orangeButton"style="font-size: 13px !important; margin-right: 10px;">
                <span><i aria-hidden="true" class="zmdi zmdi-print" style="font-size: 14px; position: relative; top: 1px;"></i> </span>
            </div>
            <div  class="darkBlueButton" (click)="backBtn()" style="display: inline-block; padding: 0px;font-size: 13px;" title="Back to Account Dashboard">
                <span><i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Back </span>              
            </div>
            <!-- <input type="text" *ngIf="selectedFY == 'Other'" class="form-control" style="width: 22%; display: inline-block; padding: 1px 3px;"> -->
        </div>

    </div>
    <!--Start Details Of Data-->

    <div class="col-md-12 webView" style="margin-bottom: 11px;padding-left: 5px; margin-top: 8px;">
        <!-- <div style="display: inline-block; margin-right: 15px;" *ngIf="imBaalance != 0">
            Imbalance : <span style="font-family: Arial;">₹</span>{{imBaalance | cRDB}}
        </div> -->
        <div style="display: inline-block; margin-right: 15px;">
            <div class="checkbox">
                <label class="font13 chkbox-darkblue" (change)="clickHideZero();"
                    style="margin-bottom: 0px !important; line-height: 30px; cursor: pointer;">
                    <input type="checkbox" [(ngModel)]="hideZeroLevelLdgr" style="margin-right: 5px; position: relative; top: 1px;">
                    Hide zeroes</label>
            </div>
        </div>
        <div style="display: inline-block; margin-right: 15px;">
            <div class="checkbox">
                <label class="font13 chkbox-darkblue" style="margin-bottom: 0px !important; line-height: 30px; cursor: pointer;">
                    <input type="checkbox" [(ngModel)]="expand" style="margin-right: 5px; position: relative;
                    top: 1px;">Expand all</label>
            </div>
        </div>


        <div class="col-md-6 col-sm-6 col-xs-6"  style="display: inline-block;font-size: 14px !important;padding-left: 0px;">
            <!-- *ngIf="selectedFY != 'Other'" -->
            <select class="form-control formCtlFltr font13 bgwhite" [(ngModel)]="selectedFY"
                (ngModelChange)="ddlchangeYear()"
                style="display: inline-block; padding: 1px 3px; font-size: 12px !important; cursor: pointer;"
                [style.width]="selectedFY == 'Other' ? '90px' : '115px'">
                <option *ngFor="let f of financialYears" [ngValue]="f.FY">FY {{f.FY}}</option>
                <option value="Other">Other</option>
            </select>

            <div style="display: inline-block; width: 68%; margin-left: 10px; " *ngIf="selectedFY == 'Other'">
                <div style="outline: none !important; display: inline-block; ">
                    <input matInput readonly (focus)="picker.open()" [(ngModel)]="toDate" [matDatepicker]="picker"
                        class="form-control formCtlFltr bgwhite" (ngModelChange)="fn_ChangeDate()"
                        style="display: inline-block; width: 90px;font-size: 12px !important; outline: none !important; cursor: pointer; background: #FFF;font-size: 13px;">
                    <mat-datepicker-toggle matSuffix [for]="picker"
                        style="display: inline-block; outline: none !important;"></mat-datepicker-toggle>
                    <mat-datepicker #picker style="outline: none !important;"></mat-datepicker>
                </div>
            </div>
        </div>


    </div>

    <!--End Details Of Data-->
    <!-- Body -->
    <div class="row marginZero webView" style="padding: 0px 5px; margin-top: 15px; padding-left: 5px;">
        <div class="col-md-12 mainCard table-bordered shadow" style="padding: 0px !important; border-radius: 3px !important;">
            <!-- Left -->
            <div class="col-md-6 mainCardHeader"
                style="display: inline-block; border-right: 1px solid #ddd; padding: 0px; vertical-align: top;">
                <div class="col-md-12"
                    style="text-align: center; border-bottom: 1px solid #ddd; background-color:white; border-top-left-radius: 10px; padding: 10px;">
                    Liabilities & Equity
                </div>
                <div class="col-md-12" *ngFor="let Heads of BindRecordLeft; let i = index"
                    style="font-size: 13px !important;">
                    <div style="margin-bottom: 10px; margin-top: {{i == 0 ? '10px' : ''}};"
                        *ngIf="(Heads.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                        <a style="font-weight: bold; cursor: pointer; color: rgb(232, 132, 33); text-decoration: none;"
                            target="{{isWeb ? '_blank' : '_self'}}"
                            (click)="expandView(Heads, 1)">{{Heads.HeadName}}</a>&nbsp;
                        <span class="pull-right" style="font-weight: bold;"><span
                                style="font-family: Arial;">₹</span>{{Heads.CloBal | cRDB}}</span>
                        <div class="col-md-12" style="padding-right: 0px; margin-bottom: 10px;" *ngIf="expand">
                            <div class="col-md-12 font12" style="padding-left: 20px; padding-right: 40px;"
                                *ngFor="let SubHead of Heads.SubHead">
                                <div *ngIf="(SubHead.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                    <a style="cursor: pointer; color: rgb(31, 98, 142); text-decoration: none;"
                                        target="{{isWeb ? '_blank' : '_self'}}"
                                        (click)="expandView(SubHead, 1)">{{SubHead.HeadName}}</a>
                                    <span class="pull-right">
                                        <span style="font-family: Arial;">₹</span>{{SubHead.CloBal | cRDB}}
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-12 font12" style="padding-left: 20px; padding-right: 40px;"
                                *ngFor="let SubLedger of Heads.Ledger">
                                <div *ngIf="(SubLedger.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                    <a style="cursor: pointer; font-style: italic; color: #4caf50; text-decoration: none;"
                                        target="{{isWeb ? '_blank' : '_self'}}"
                                        (click)="expandView(SubLedger, 0)">{{SubLedger.LedgerName}}</a>
                                    <span class="pull-right">
                                        <span style="font-family: Arial;">₹</span>{{SubLedger.CloBal | cRDB}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="col-md-12" *ngIf="profitLoss.length == 0" style="font-size: 14px !important;">
                <div style="margin-bottom: 10px;" *ngIf="ProfitOrLoss > 0">
                    <span style="font-weight: bold;">Current Profit</span> &nbsp;
                    <span class="pull-right" style="font-weight: bold;"><span
                            style="font-family: Arial;">₹</span>{{ProfitOrLoss | cRDB}} </span>
                </div>
            </div> -->

                <div class="col-md-12 font12" *ngFor="let param of profitLoss" style="font-size: 12px !important;">
                    <div *ngIf="profitLoss.length > 0 && param.totalProfitAndLoss < 0">
                        <div (click)="goToPAndL();" style="cursor: pointer;">
                            <span style="font-weight: bold;">{{param.LedgerName}}</span> &nbsp;
                            <span class="pull-right" style="font-weight: bold;"><span
                                    style="font-family: Arial;">₹</span>{{param.totalProfitAndLoss | cRDB}}</span>
                        </div>
                        <div class="col-md-12" style="padding-right: 0px; margin-bottom: 10px;">
                            <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;">
                                <span>Opening Balance</span>
                                <span class="pull-right"><span
                                        style="font-family: Arial;">₹</span>{{param.openingProfitAndLoss | cRDB}}</span>
                            </div>
                            <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;">
                                <span>Current Period</span>
                                <span class="pull-right"><span
                                        style="font-family: Arial;">₹</span>{{param.currentProfitAndLoss | cRDB}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 font12" *ngFor="let Stock of AccurateProfitOrLoss"
                    style="font-size: 12px !important;">
                    <div style="margin-bottom: 10px;" [hidden]="Stock.AccruedProfit == 0">
                        <span style="font-weight: bold;">Accrued Profit</span> &nbsp;
                        <span class="pull-right" style="font-weight: bold;"><span
                                style="font-family: Arial;">₹</span>{{Stock.AccruedProfit | cRDB}}</span>
                    </div>
                </div>


            </div>
            <!-- Right -->
            <div class="col-md-6 mainCardHeader"
                style="display: inline-block; border-left: 1px solid #ddd; padding: 0px; vertical-align: top;">
                <div class="col-md-12"
                    style="text-align: center; border-bottom: 1px solid #ddd; background-color: white; border-top-right-radius: 10px; padding: 10px;">
                    Assets
                </div>
                <div class="col-md-12" *ngFor="let Heads of BindRecordRight; let i = index"
                    style="font-size: 13px !important;">
                    <div style="margin-bottom: 10px; margin-top: {{i == 0 ? '10px' : ''}};"
                        *ngIf="(Heads.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                        <a style="font-weight: bold; cursor: pointer; color: rgb(232, 132, 33); text-decoration: none;"
                            target="{{isWeb ? '_blank' : '_self'}}"
                            (click)="expandView(Heads, 1)">{{Heads.HeadName}}</a>&nbsp;
                        <span class="pull-right" style="font-weight: bold;"><span
                                style="font-family: Arial;">₹</span>{{Heads.CloBal | cRDB}}</span>
                        <div class="col-md-12" style="padding-right: 0px; margin-bottom: 10px;" *ngIf="expand">
                            <div class="col-md-12 font12" style="padding-left: 20px; padding-right: 40px;"
                                *ngFor="let SubHead of Heads.SubHead">
                                <div *ngIf="(SubHead.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                    <a style="cursor: pointer; color: rgb(31, 98, 142); text-decoration: none;"
                                        target="{{isWeb ? '_blank' : '_self'}}"
                                        (click)="expandView(SubHead, 1)">{{SubHead.HeadName}}</a>
                                    <span class="pull-right">
                                        <span style="font-family: Arial;">₹</span>{{SubHead.CloBal | cRDB}}
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-12 font12" style="padding-left: 20px; padding-right: 40px;"
                                *ngFor="let SubLedger of Heads.Ledger">
                                <div *ngIf="(SubLedger.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                    <a style="cursor: pointer; font-style: italic; color:#4caf50; text-decoration: none;"
                                        target="{{isWeb ? '_blank' : '_self'}}"
                                        (click)="expandView(SubLedger, 0)">{{SubLedger.LedgerName}}</a>
                                    <span class="pull-right">
                                        <span style="font-family: Arial;">₹</span>{{SubLedger.CloBal | cRDB}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" *ngIf="profitLoss.length == 0" style="font-size: 13px !important;">
                    <div style="margin-bottom: 10px;" *ngIf="ProfitOrLoss < 0">
                        <span style="font-weight: bold;">Current Loss</span> &nbsp;
                        <span class="pull-right" style="font-weight: bold;"><span
                                style="font-family: Arial;">₹</span>{{ProfitOrLoss | cRDB}}</span>
                    </div>
                </div>

                <div class="col-md-12 font12" *ngFor="let param of profitLoss" style="font-size: 12px !important;">
                    <div *ngIf="profitLoss.length > 0 && param.totalProfitAndLoss > 0">
                        <div style="margin-bottom: 10px; cursor: pointer;" (click)="goToPAndL();">
                            <span style="font-weight: bold;">{{param.LedgerName}}</span> &nbsp;
                            <span class="pull-right" style="font-weight: bold;"><span
                                    style="font-family: Arial;">₹</span>{{param.totalProfitAndLoss | cRDB}}</span>

                            <div class="col-md-12" style="padding-right: 0px; margin-bottom: 10px;">
                                <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;">
                                    <span>Opening Balance</span>
                                    <span class="pull-right"><span
                                            style="font-family: Arial;">₹</span>{{param.openingProfitAndLoss |
                                        cRDB}}</span>
                                </div>
                                <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;">
                                    <span> Current Period</span>
                                    <span class="pull-right"><span
                                            style="font-family: Arial;">₹</span>{{param.currentProfitAndLoss |
                                        cRDB}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" *ngFor="let Stock of AccurateProfitOrLoss" style="font-size: 13px !important;">
                    <div style="margin-bottom: 10px;"
                        *ngIf="(Stock.ClosingStock != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                        <span style="font-weight: bold;">Stock</span> &nbsp;
                        <span class="pull-right" style="font-weight: bold;font-size: 13px;"><span
                                style="font-family: Arial;">₹</span>{{Stock.ClosingStock | cRDB}}</span>
                    </div>
                    <div style="margin-bottom: 10px;" [hidden]="Stock.AccruedLoss == 0">
                        <span style="font-weight: bold;">Accrued Loss</span> &nbsp;
                        <span class="pull-right" style="font-weight: bold;"><span
                                style="font-family: Arial;">₹</span>{{Stock.AccruedLoss | cRDB}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12 table-bordered shadow"
            style="padding-left: 0px; border-radius: 3px !important; padding-right: 0px; border-top: none; margin-bottom: 10px; border-bottom-left-radius: 10px; border-bottom-right-radius: 10px; font-size: 14px;background-color: white;"
            id="MainDiv1">
            <div class="col-md-6"
                style="border-right: 1px solid #ddd; padding-left: 0px; padding-right: 0px; display: inline-block;">
                <div class="col-md-12" style="padding-top: 10px; padding-bottom: 3px;">
                    <div style="margin-bottom: 10px;">
                        <span style="font-weight: bold; font-size: 13px;">Total</span>
                        <span class="pull-right font13" style="font-weight: bold;"><span
                                style="font-family: Arial;">₹</span>{{leftBal | cRDB}}</span>
                    </div>
                </div>
            </div>

            <div class="col-md-6" style="padding-left: 0px; padding-right: 0px; display: inline-block;">
                <div class="col-md-12" style="padding-top: 10px;">
                    <div style="margin-bottom: 10px;">
                        <span style="font-weight: bold; font-size: 13px;">Total</span>
                        <span class="pull-right font13" style="font-weight: bold;"><span
                                style="font-family: Arial;">₹</span>{{rightBal | cRDB}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<div class="container-fluid mobView">
    <!-- Header -->
    <div class="row">

        <div class="col-md-6" style="display: inline-block; padding: 20px; font-size: 30px; padding-bottom: 0px;">

            <!-- <span class="mobViewBtnBack" style="font-size: 22px; margin-right: 10px;" (click)="backBtn()"><i
                    class="fa fa-chevron-left"></i>
            </span> -->

            <h4 class="newHeader" style="display: inline-block;">Balance Sheet</h4>            
            <span class="btn darkBlueButton" 
                style="margin-left: 7px !important; float: right; position: relative; padding: 2px 9px; top: 1px; border-radius: 25px; line-height: 1.66em;" 
                (click)="backBtn()">
                    <i class="zmdi zmdi-arrow-left" style="margin-right: 5px;"></i>Back
            </span>
           
        </div>
        <div class="col-md-6" style="text-align: left; padding-top: 10px;">
            <div style="margin-bottom: 10px;">
                <div class="label greenBadge brdrRadius3"
                    style="padding: 5px 12px 5px 12px; font-size: 13px; display: inline-block;">
                    This Year
                </div>

                <!-- <span class="calender mobView" style="color: #e88421;padding: 1px 0px 5px 7px;"> <i
                        class="fa fa-calendar" aria-hidden="true"></i></span> -->

                <select class="form-control formCtlFltr brdrRadius3 font13" placeholder="Other" [(ngModel)]="selectedFY"
                    (ngModelChange)="ddlchangeYear()" style="display: inline-block; margin-left: 10px;  "
                    [style.width]="selectedFY == 'Other' ? '90px' : '115px'">
                    <!-- <option value="0" selected disabled hidden>Other</option> -->
                    <option *ngFor="let f of financialYears" [ngValue]="f.FY">FY {{f.FY}}</option>
                    <option value="Other">Other</option>
                </select>
                <!-- 
                <div style="display: inline-block;; margin-left: 20px; " *ngIf="selectedFY == 'Other'">
                    <input matInput readonly (focus)="picker.open()" [(ngModel)]="toDate" [matDatepicker]="picker"
                        class="form-control" (ngModelChange)="fn_ChangeDate()"
                        style="display: inline-block; outline: none !important; cursor: pointer; background: #FFF;font-size: 13px;">
                    <mat-datepicker-toggle matSuffix [for]="picker"
                        style="display: inline-block; outline: none !important;"></mat-datepicker-toggle>
                    <mat-datepicker #picker style="outline: none !important;"></mat-datepicker>
                </div> -->

                <div style="display: inline-block;width: 40%; margin-left: 10px;" *ngIf="selectedFY == 'Other'">

                    <div style="outline: none !important; display: flex; align-items: baseline;">
                        <input matInput readonly (focus)="picker2.open()" [matDatepicker]="picker2" class="form-control  font12 formCtlFltr BzBgwhite brdrRadius3" [(ngModel)]="toDate" (ngModelChange)="fn_ChangeDate()" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 90px !important; padding: 0 8px; box-sizing: border-box;">
                        <mat-datepicker-toggle matSuffix [for]="picker2"
                            style="display: inline-block; outline: none !important;"></mat-datepicker-toggle>
                        <mat-datepicker #picker2 style="outline: none !important;"></mat-datepicker>
                    </div>
                </div>

            </div>
            <!-- <div class="label Bluebadge" style="padding: 5px 12px 5px 12px; font-size: 13px; display: inline-block; margin-left: 10px;">
                    Other
                </div> -->
        </div>


        <div style="display: inline-block;margin: 0px 15px 10px 15px;">
            <div class="checkbox">
                <label class="font13" style="margin-bottom: 0px !important; line-height: 30px; cursor: pointer;">
                    <input type="checkbox" [(ngModel)]="hideZeroLevelLdgr"
                        style="margin-right: 5px;height: 13px;vertical-align: middle;">Hide
                    zeroes</label>
            </div>
        </div>
        <div style="display: inline-block; margin-right: 15px;">
            <div class="checkbox">
                <label class="font13" style="margin-bottom: 0px !important; line-height: 30px; cursor: pointer;">
                    <input type="checkbox" [(ngModel)]="expand"
                        style="margin-right: 5px;height: 13px;vertical-align: middle;">Expand
                    All</label>
            </div>
        </div>
    </div>
    <!-- </div> -->

    <!-- Body -->
    <div class="row marginZero">
        <div class="col-md-12" style="padding: 0px !important;">
            <!-- Left -->
            <div class="col-md-6 col-12 mainCardHeader shadow"
                style="display: inline-block; padding: 0px; vertical-align: top; border: 1px solid #ddd;border-radius: 3px;">
                <div class="col-md-12" (click)="isShowLiabilities = !isShowLiabilities"
                    style="text-align: left; background-color: rgb(245, 245, 245); border-top-left-radius: 10px; border-top-right-radius: 10px; padding: 10px; {{isShowLiabilities ? ' border-bottom: 1px solid #ddd;' : ''}} padding-left: 15px; padding-right: 15px;">
                    <div class="col-8" style="padding: 0px; display: inline-block;">
                        Liabilities & Equity
                    </div>
                    <div class="col-4" style="text-align: right; padding: 0px; display: inline-block;">
                        <i class="fa fa-expand" aria-hidden="true"></i>
                    </div>
                </div>

                <div *ngIf="isShowLiabilities">
                    <div class="col-md-12 font13" *ngFor="let Heads of BindRecordLeft">
                        <div style="margin-bottom: 10px; margin-top: 10px;"
                            *ngIf="(Heads.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                            <span style="font-weight: bold; cursor: pointer; color: rgb(232, 132, 33);"
                                [routerLink]="['/accounts', {id: Heads.HeadID, h:1}]">{{Heads.HeadName}}</span>&nbsp;
                            <span class="pull-right" style="font-weight: bold;"><span
                                    style="font-family: Arial;">₹</span>{{Heads.CloBal | cRDB}}</span>
                            <div class="col-md-12" style="padding-right: 0px; margin-bottom: 10px; padding-left: 0px;"
                                *ngIf="expand">
                                <div class="col-md-12" style="padding-left: 10px; padding-right: 10px;"
                                    *ngFor="let SubHead of Heads.SubHead">
                                    <div
                                        *ngIf="(SubHead.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                        <span style="cursor: pointer; color: rgb(232, 132, 33);"
                                            class="ellipsis">{{SubHead.HeadName}}</span>
                                        <span class="pull-right"><span
                                                style="font-family: Arial;">₹</span>{{SubHead.CloBal
                                            | cRDB}}</span>
                                    </div>
                                </div>
                                <div class="col-md-12 font12" style="padding-left: 10px; padding-right: 10px;"
                                    *ngFor="let SubLedger of Heads.Ledger">
                                    <div
                                        *ngIf="(SubLedger.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                        <span class="ellipsis"
                                            style="cursor: pointer; font-style: italic; color: rgb(31, 98, 142);"
                                            [routerLink]="['/accounts', {id: SubLedger.LedgerID, h:0}]">{{SubLedger.LedgerName}}</span>
                                        <span class="pull-right"><span
                                                style="font-family: Arial;">₹</span>{{SubLedger.CloBal | cRDB}}</span>
                                    </div>
                                </div>

                                <div class="col-md-12 font12" *ngIf="profitLoss.length == 0">
                                    <div style="margin-bottom: 10px;" *ngIf="ProfitOrLoss < 0">
                                        <span style="font-weight: bold;">Current Loss</span> &nbsp;
                                        <span class="pull-right" style="font-weight: bold;"><span
                                                style="font-family: Arial;">₹</span>{{ProfitOrLoss | cRDB}}</span>
                                    </div>
                                </div>

                                <div class="col-md-12 font12" *ngIf="profitLoss.length == 0">
                                    <div style="margin-bottom: 10px;" *ngIf="ProfitOrLoss > 0">
                                        <span style="font-weight: bold;">Current Profit</span> &nbsp;
                                        <span class="pull-right" style="font-weight: bold;"><span
                                                style="font-family: Arial;">₹</span>{{ProfitOrLoss | cRDB}} </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 font12" *ngFor="let param of profitLoss">
                        <div *ngIf="profitLoss.length > 0 && param.totalProfitAndLoss < 0">
                            <div (click)="goToPAndL();" style="cursor: pointer;">
                                <span style="font-weight: bold;">{{param.LedgerName}}</span> &nbsp;
                                <span class="pull-right" style="font-weight: bold;"><span
                                        style="font-family: Arial;">₹</span>{{param.totalProfitAndLoss | cRDB}}</span>
                            </div>
                            <div class="col-md-12 font12"
                                style="padding-right: 0px; margin-bottom: 10px;">
                                <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;">
                                    <span>Opening Balance</span>
                                    <span class="pull-right"><span
                                            style="font-family: Arial;">₹</span>{{param.openingProfitAndLoss |
                                        cRDB}}</span>
                                </div>
                                <div class="col-md-12 font12" style="padding-left: 20px; padding-right: 40px;">
                                    <span>Current Period</span>
                                    <span class="pull-right"><span
                                            style="font-family: Arial;">₹</span>{{param.currentProfitAndLoss |
                                        cRDB}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 font12" *ngFor="let Stock of AccurateProfitOrLoss">
                        <div style="margin-bottom: 10px;" [hidden]="Stock.AccruedProfit == 0">
                            <span style="font-weight: bold;">Accrued Profit</span> &nbsp;
                            <span class="pull-right" style="font-weight: bold;"><span
                                    style="font-family: Arial;">₹</span>{{Stock.AccruedProfit | cRDB}}</span>
                        </div>
                    </div>
                </div>

                <div class="col-md-12"
                    style="padding-left: 0px; padding-right: 0px; display: inline-block; border-top: 1px solid #ddd; font-size: 13px;">
                    <div class="col-md-12" style="padding-top: 10px; padding-bottom: 3px;">
                        <div style="margin-bottom: 10px;">
                            <span style="font-weight: bold;">Total</span>
                            <span class="pull-right" style="font-weight: bold;"><span
                                    style="font-family: Arial;">₹</span>{{leftBal | cRDB}}</span>
                        </div>
                    </div>
                </div>
            </div>


            <!-- Right -->
            <div class="col-md-6 mainCardHeader shadow"
                style="display: inline-block; padding: 0px; vertical-align: top; border: 1px solid #ddd; margin-top: 15px;border-radius: 3px;">
                <div class="col-md-12" (click)="isShowAssets = !isShowAssets"
                    style="text-align: left; background-color:rgb(245, 245, 245); border-top-right-radius: 3px; border-top-left-radius: 3px; padding: 10px; {{isShowAssets ? ' border-bottom: 1px solid #ddd;' : ''}} padding-left: 15px; padding-right: 15px;">
                    <div class="col-8" style="padding: 0px; display: inline-block;">
                        Assets
                    </div>
                    <div class="col-4" style="text-align: right; padding: 0px; display: inline-block;">
                        <i class="fa fa-expand" aria-hidden="true"></i>
                    </div>
                </div>

                <div *ngIf="isShowAssets">
                    <div class="col-md-12 font13" *ngFor="let Heads of BindRecordRight">
                        <div style="margin-bottom: 10px; margin-top: 10px;"
                            *ngIf="(Heads.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                            <span style="font-weight: bold; cursor: pointer; color: rgb(232, 132, 33);"
                                [routerLink]="['/accounts', {id: Heads.HeadID, h:1}]">{{Heads.HeadName}}</span>&nbsp;
                            <span class="pull-right" style="font-weight: bold;"><span
                                    style="font-family: Arial;">₹</span>{{Heads.CloBal | cRDB}}</span>
                            <div class="col-md-12" style="padding-right: 0px; margin-bottom: 10px;" *ngIf="expand">
                                <div class="col-md-12 font12" style="padding-left: 10px; padding-right: 10px;"
                                    *ngFor="let SubHead of Heads.SubHead">
                                    <div
                                        *ngIf="(SubHead.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                        <span
                                            style="cursor: pointer; color: rgb(232, 132, 33);">{{SubHead.HeadName}}</span>
                                        <span class="pull-right"><span
                                                style="font-family: Arial;">₹</span>{{SubHead.CloBal
                                            | cRDB}}</span>
                                    </div>
                                </div>
                                <div class="col-md-12 font12" style="padding-left: 10px; padding-right: 10px;"
                                    *ngFor="let SubLedger of Heads.Ledger">
                                    <div
                                        *ngIf="(SubLedger.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                        <span style="cursor: pointer; font-style: italic; color: rgb(31, 98, 142);"
                                            [routerLink]="['/accounts', {id: SubLedger.LedgerID, h:0}]">{{SubLedger.LedgerName}}</span>
                                        <span class="pull-right"><span
                                                style="font-family: Arial;">₹</span>{{SubLedger.CloBal | cRDB}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 font12" *ngIf="profitLoss.length == 0">
                        <div style="margin-bottom: 10px;" *ngIf="ProfitOrLoss < 0">
                            <span style="font-weight: bold;">Current Loss</span> &nbsp;
                            <span class="pull-right" style="font-weight: bold;"><span
                                    style="font-family: Arial;">₹</span>{{ProfitOrLoss | cRDB}}</span>
                        </div>
                    </div>

                    <div class="col-md-12 font12" *ngFor="let param of profitLoss">
                        <div *ngIf="profitLoss.length > 0 && param.totalProfitAndLoss > 0">
                            <div style="margin-bottom: 10px; cursor: pointer;" (click)="goToPAndL();">
                                <span style="font-weight: bold;">{{param.LedgerName}}</span> &nbsp;
                                <span class="pull-right" style="font-weight: bold;"><span
                                        style="font-family: Arial;">₹</span>{{param.totalProfitAndLoss | cRDB}}</span>

                                <div class="col-md-12 font12"
                                    style="padding-right: 0px; margin-bottom: 10px;">
                                    <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;">
                                        <span>Opening Balance</span>
                                        <span class="pull-right"><span
                                                style="font-family: Arial;">₹</span>{{param.openingProfitAndLoss |
                                            cRDB}}</span>
                                    </div>
                                    <div class="col-md-12 font12" style="padding-left: 20px; padding-right: 40px;">
                                        <span style="cursor: pointer;" [routerLink]="['/profitandLoss']">Current
                                            Period</span>
                                        <span class="pull-right"><span
                                                style="font-family: Arial;">₹</span>{{param.currentProfitAndLoss |
                                            cRDB}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 font12" *ngFor="let Stock of AccurateProfitOrLoss">
                        <div style="margin-bottom: 10px; cursor: pointer;" (click)="goToStockSummary()"
                            *ngIf="(Stock.ClosingStock != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                            <span style="font-weight: bold;">Stock</span> &nbsp;
                            <span class="pull-right" style="font-weight: bold;"><span
                                    style="font-family: Arial;">₹</span>{{Stock.ClosingStock | cRDB}}</span>
                        </div>
                        <div class="font12" style="margin-bottom: 10px;" [hidden]="Stock.AccruedLoss == 0">
                            <span style="font-weight: bold;">Accrued Loss</span> &nbsp;
                            <span class="pull-right" style="font-weight: bold;"><span
                                    style="font-family: Arial;">₹</span>{{Stock.AccruedLoss | cRDB}}</span>
                        </div>
                    </div>
                </div>

                <div class="col-md-12"
                    style="padding-left: 0px; padding-right: 0px; display: inline-block; border-top: 1px solid #ddd; font-size: 13px;">
                    <div class="col-md-12" style="padding-top: 10px;">
                        <div style="margin-bottom: 10px;">
                            <span style="font-weight: bold;">Total</span>
                            <span class="pull-right" style="font-weight: bold;"><span
                                    style="font-family: Arial;">₹</span>{{rightBal | cRDB}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>

<!-- <ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">

</ngx-spinner> -->